import React from 'react';

interface IconProps {
    height?: number;
    alt?: string;
}

const CheckIcon: React.FC<IconProps> = ({ height = 30, alt = "Check" }) => {
    return <img src="/check.png" alt={alt} style={{ height: `${height}px` }} />;
};

export default CheckIcon;
